/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Time_Audio_LabelInputs */

const en_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate timing by audio duration`)
};

const fr_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculer le minutage par durée audio`)
};

const de_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitberechnung anhand der Audiodauer`)
};

const it_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il tempo in base alla durata dell'audio`)
};

const ru_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рассчитайте время по длительности аудиозаписи.`)
};

const es_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular el tiempo por duración del audio`)
};

const zh_cn2_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据音频时长计算时间`)
};

const ja_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオの長さからタイミングを計算する`)
};

const hi_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो की अवधि के आधार पर समय की गणना करें`)
};

const pt_pt2_context_menu_auto_time_audio_label = /** @type {(inputs: Context_Menu_Auto_Time_Audio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o tempo com base na duração do áudio.`)
};

/**
* | output |
* | --- |
* | "Calculate timing by audio duration" |
*
* @param {Context_Menu_Auto_Time_Audio_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_time_audio_label = /** @type {((inputs?: Context_Menu_Auto_Time_Audio_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Time_Audio_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_auto_time_audio_label(inputs)
	if (locale === "de") return de_context_menu_auto_time_audio_label(inputs)
	if (locale === "it") return it_context_menu_auto_time_audio_label(inputs)
	if (locale === "ru") return ru_context_menu_auto_time_audio_label(inputs)
	if (locale === "es") return es_context_menu_auto_time_audio_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_auto_time_audio_label(inputs)
	if (locale === "ja") return ja_context_menu_auto_time_audio_label(inputs)
	if (locale === "hi") return hi_context_menu_auto_time_audio_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_auto_time_audio_label(inputs)
	return en_context_menu_auto_time_audio_label(inputs)
});